import { Grid, Stack } from "@mui/material";
import React from "react";
import IndexProcedureVisitCard from "./IndexProcedureVisitCard";
import PatientCard from "./PatientCard";
import VisitsDiagnosesProcedures from "./VisitsDiagnosesProcedures";

export default function SelectedPatientMainBody() {
  return (
    <Grid className={"data"} container spacing={2}>
      <Grid className={"selected-patient-main-body-column-left"}>
        <Stack spacing={2}>
          <PatientCard />
          <IndexProcedureVisitCard />
        </Stack>
      </Grid>
      <Grid className={"selected-patient-main-body-column-right"}>
        <VisitsDiagnosesProcedures />
      </Grid>
    </Grid>
  );
}
